import { useMutation } from '@tanstack/react-query';

import { fetchListTwoHistoryLogsApi } from '../api';

export default function useListTwoLogsMutation(options?: any) {
  return useMutation(fetchListTwoHistoryLogsApi, options);
}
